module.exports = __webpack_public_path__ + "assets/img/wback.7b5ea7ac.png";